import { CommunicationType } from '../models/communication.ts';

type IApplicationID = string;
export type ITabType = 'Original' | 'Draft' | 'Request';

export interface IApplication {
  applicationID: IApplicationID;
  humanReadableID: string;
  marketCountry: string;
  communicationTab: CommunicationType;
}

export interface IOpenApplications {
  [key: IApplicationID]: IApplication;
}

export type State = {
  marketCountry: string | undefined;
  error: string | undefined;
  openApplications: IOpenApplications;
};

export const initialState: State = {
  marketCountry: undefined,
  error: undefined,
  openApplications: {},
};

export const initializer = (initialValue = initialState) => {
  const storedState = sessionStorage.getItem('applicationData');
  if (!storedState) return initialValue;
  return JSON.parse(sessionStorage.getItem('applicationData') || '');
};
